export const setActiveBenefits = data =>
  data.map(elem => {
    return { name: elem, checked: true };
  });
